/* BLP Offers – storefront behaviour (replaces Koala Upsells & Gifts)
 * - product page: show/hide variant-specific offers, add ticked upsells on Add to Cart
 * - cart: auto-add free gifts when a trigger product is added, remove them when the trigger leaves,
 *         keep gift quantity fixed. Lines carry _blp_offer (offer id) + _blp_trigger (trigger variant).
 * Discounts themselves are applied at checkout by the BLP Offers discount function.
 */
(function () {
  'use strict';
  if (window.__blpOffersLoaded) return;
  window.__blpOffersLoaded = true;

  var OFFER_PROP = '_blp_offer';
  var TRIG_PROP = '_blp_trigger';
  var cfg = { gifts: [] };
  try {
    var el = document.getElementById('blp-offers-config');
    if (el) cfg = JSON.parse(el.textContent);
  } catch (e) { cfg = { gifts: [] }; }

  var SELF = 'X-BLP-Offers';
  var reconcileTimer = null;
  var busy = false;
  var lastWasAdd = false;

  function routes() {
    var r = (window.FoxTheme && window.FoxTheme.routes) || {};
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return {
      add: r.cart_add_url || root + 'cart/add.js',
      change: r.cart_change_url || root + 'cart/change.js',
      cart: (r.cart_url || root + 'cart') + '.js'
    };
  }

  function ownFetch(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json' }, opts.headers || {});
    opts.headers[SELF] = '1';
    return fetch(url, opts);
  }

  function getCart() {
    return ownFetch(routes().cart, { method: 'GET' }).then(function (r) { return r.json(); });
  }

  function str(x) { return x == null ? '' : String(x); }

  // ---------- gift logic ----------
  function giftOffersFor(line) {
    // offers triggered by a cart line (product/variant triggers only; collection triggers come from the product page)
    var pid = str(line.product_id), vid = str(line.variant_id);
    return cfg.gifts.filter(function (o) {
      return (o.p || []).indexOf(pid) >= 0 || (o.v || []).indexOf(vid) >= 0;
    });
  }

  var pendingPageTriggers = [];
  function reconcile(extraTriggers) {
    // extraTriggers: [{offerId, triggerVariant}] offers triggered from the product page (collection triggers)
    if (extraTriggers && extraTriggers.length) pendingPageTriggers = pendingPageTriggers.concat(extraTriggers);
    if (busy) { scheduleReconcile(); return Promise.resolve(); }
    busy = true;
    extraTriggers = pendingPageTriggers; pendingPageTriggers = [];
    var changed = false;
    return getCart().then(function (cart) {
      var items = cart.items || [];
      var normal = items.filter(function (i) { return !(i.properties && i.properties[OFFER_PROP]); });
      var gifts = items.filter(function (i) { return i.properties && i.properties[OFFER_PROP]; });
      var byId = {};
      cfg.gifts.forEach(function (o) { byId[o.id] = o; });

      // desired gift lines: {offerId, triggerVariant, variant, qty}
      var desired = [];
      normal.forEach(function (line) {
        giftOffersFor(line).forEach(function (o) {
          o.r.forEach(function (rw) {
            desired.push({ offer: o.id, trig: str(line.variant_id), v: str(rw.v), q: rw.q || 1 });
          });
        });
      });
      (extraTriggers || []).forEach(function (t) {
        var o = byId[t.offerId];
        if (!o) return;
        var hasTrig = normal.some(function (l) { return str(l.variant_id) === str(t.triggerVariant); });
        if (!hasTrig) return;
        o.r.forEach(function (rw) {
          desired.push({ offer: o.id, trig: str(t.triggerVariant), v: str(rw.v), q: rw.q || 1 });
        });
      });

      var ops = [];
      // remove / fix existing gift lines
      gifts.forEach(function (g) {
        var oid = g.properties[OFFER_PROP];
        var o = byId[oid];
        if (!o) return; // not a gift offer (upsell line) – leave alone
        var trig = str(g.properties[TRIG_PROP]);
        var stillTriggered = normal.some(function (l) { return str(l.variant_id) === trig; });
        if (!stillTriggered && trig) {
          // trigger left the cart – check whether any other line triggers the same offer
          stillTriggered = normal.some(function (l) { return giftOffersFor(l).some(function (x) { return x.id === oid; }); });
        }
        var want = desired.find(function (d) { return d.offer === oid && d.v === str(g.variant_id); });
        if (!want && stillTriggered) {
          // collection-triggered gift (added from the product page): its trigger line is still
          // in the cart and the line carries the offer id, so keep it rather than re-deriving it
          var rw = o.r.find(function (x) { return str(x.v) === str(g.variant_id); });
          if (rw) want = { offer: oid, trig: trig, v: str(g.variant_id), q: rw.q || 1 };
        }
        if (!stillTriggered || !want) {
          ops.push({ id: g.key, quantity: 0 });
        } else if (g.quantity !== want.q) {
          ops.push({ id: g.key, quantity: want.q });
        }
      });
      // add missing gift lines
      var adds = [];
      desired.forEach(function (d) {
        var exists = gifts.some(function (g) { return g.properties[OFFER_PROP] === d.offer && str(g.variant_id) === d.v; });
        var queued = adds.some(function (a) { return a.properties[OFFER_PROP] === d.offer && str(a.id) === d.v; });
        if (!exists && !queued) {
          var props = {}; props[OFFER_PROP] = d.offer; props[TRIG_PROP] = d.trig;
          adds.push({ id: Number(d.v), quantity: d.q, properties: props });
        }
      });

      var chain = Promise.resolve();
      ops.forEach(function (op) {
        chain = chain.then(function () {
          changed = true;
          return ownFetch(routes().change, { method: 'POST', body: JSON.stringify(op) });
        });
      });
      if (adds.length) {
        chain = chain.then(function () {
          changed = true;
          return ownFetch(routes().add, { method: 'POST', body: JSON.stringify({ items: adds }) })
            .then(function (r) { return r.ok ? r : r.json().then(function (j) { console.warn('BLP Offers: gift add failed', j); }); });
        });
      }
      return chain;
    }).then(function () {
      busy = false;
      if (changed) refreshCartUI();
    }).catch(function (e) { busy = false; console.warn('BLP Offers reconcile error', e); });
  }

  function scheduleReconcile(extra) {
    clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(function () { reconcile(extra); }, 350);
  }

  function refreshCartUI() {
    var nativeDrawer = document.querySelector('cart-drawer');
    var wantOpen = lastWasAdd;
    lastWasAdd = false;
    if (nativeDrawer) {
      // Native theme cart drawer: ask Shopify for the cart plus the drawer section HTML in one
      // call (same as the theme's own product form), publish it, and open the drawer after an add.
      var sections = [];
      try { document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })); } catch (e) {}
      ownFetch(routes().change.replace('/change', '/update'), { method: 'POST', body: JSON.stringify({ sections: sections.join(','), sections_url: window.location.pathname }) })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          try {
            if (window.FoxTheme && FoxTheme.pubsub && cart.sections) FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
            else document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
          } catch (e) {}
          try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } })); } catch (e) {}
          if (wantOpen && !nativeDrawer.open && typeof nativeDrawer.show === 'function') nativeDrawer.show();
        })
        .catch(function (e) { console.warn('BLP Offers: cart refresh failed', e); });
      return;
    }
    getCart().then(function (cart) {
      try {
        if (window.FoxTheme && FoxTheme.pubsub) FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
      } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } })); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } })); } catch (e) {}
      try {
        var drawerOpen = document.querySelector('.amp-cart--open, .amp-cart-drawer[aria-hidden="false"]');
        if (window.AMP_API && typeof AMP_API.OPEN_CART === 'function' && (drawerOpen || wantOpen)) AMP_API.OPEN_CART();
      } catch (e) {}
    });
  }

  // ---------- cart drawer upsells (BLP Offers add-ons rendered by snippets/blp-cart-upsells.liquid) ----------
  function bindCartUpsells(root) {
    (root || document).querySelectorAll('blp-cart-upsells').forEach(function (el) {
      if (el.__blp) return; el.__blp = true;
      var track = el.querySelector('.blp-cu__track');
      var prev = el.querySelector('.blp-cu__arrow--prev');
      var next = el.querySelector('.blp-cu__arrow--next');
      var dots = el.querySelectorAll('.blp-cu__dot');
      function step() { var c = track.querySelector('.blp-cu__card'); return c ? c.getBoundingClientRect().width + 10 : track.clientWidth; }
      function index() { return Math.round(track.scrollLeft / step()); }
      function update() {
        var i = index(), n = track.querySelectorAll('.blp-cu__card').length;
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= n - 1;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      update();
      el.querySelectorAll('.blp-cu__select').forEach(function (sel) {
        sel.addEventListener('change', function () {
          var card = sel.closest('.blp-cu__card');
          var opt = sel.options[sel.selectedIndex];
          var price = Number(opt.dataset.price || 0);
          var type = card.dataset.discType, val = Number(card.dataset.discValue || 0);
          var now = type === 'amt' ? Math.max(0, price - Math.round(val * 100)) : Math.round(price * (100 - val) / 100);
          card.dataset.variant = sel.value;
          var nowEl = card.querySelector('.blp-cu__now'), wasEl = card.querySelector('.blp-cu__was');
          if (nowEl) nowEl.textContent = money(now);
          if (wasEl) wasEl.textContent = money(price);
        });
      });
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.blp-cu__btn');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('.blp-cu__card');
    var props = {}; props[OFFER_PROP] = card.dataset.offer;
    btn.disabled = true; btn.textContent = '…';
    lastWasAdd = true;
    ownFetch(routes().add, { method: 'POST', body: JSON.stringify({ items: [{ id: Number(card.dataset.variant), quantity: 1, properties: props }] }) })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { btn.textContent = (j && j.description) ? 'N/A' : 'Retry'; btn.disabled = false; lastWasAdd = false; });
        btn.textContent = 'ADDED';
        refreshCartUI();
        scheduleReconcile();
      })
      .catch(function () { btn.textContent = 'ADD'; btn.disabled = false; lastWasAdd = false; });
  });
  // rotating promo bar in the cart drawer (one timer; survives section re-renders)
  var barTimer = null;
  function tickBar() {
    var bar = document.querySelector('cart-drawer .blp-cd__bar');
    if (!bar) return;
    var slides = bar.querySelectorAll('.blp-cd__bar-slide');
    if (slides.length < 2) return;
    var i = 0;
    slides.forEach(function (sl, k) { if (sl.classList.contains('is-active')) i = k; });
    var n = (i + 1) % slides.length;
    slides.forEach(function (sl, k) { sl.classList.toggle('is-active', k === n); if (k === n) sl.removeAttribute('aria-hidden'); else sl.setAttribute('aria-hidden', 'true'); });
  }
  function startBar() {
    var bar = document.querySelector('cart-drawer .blp-cd__bar');
    clearInterval(barTimer);
    if (!bar || bar.querySelectorAll('.blp-cd__bar-slide').length < 2) return;
    barTimer = setInterval(tickBar, Math.max(2000, Number(bar.dataset.speed) || 4000));
  }
  var cuObserver = new MutationObserver(function () { bindCartUpsells(); if (!document.querySelector('cart-drawer .blp-cd__bar[data-bound]')) { var b = document.querySelector('cart-drawer .blp-cd__bar'); if (b) { b.setAttribute('data-bound', '1'); startBar(); } } });
  function watchCartDrawer() {
    var cd = document.querySelector('cart-drawer');
    if (cd) cuObserver.observe(cd, { childList: true, subtree: true });
    bindCartUpsells();
    var b0 = document.querySelector('cart-drawer .blp-cd__bar'); if (b0) { b0.setAttribute('data-bound', '1'); startBar(); }
  }

  // ---------- intercept cart mutations made by the theme / other apps ----------
  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
  }
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var own = init && init.headers && (init.headers[SELF] || (init.headers.get && init.headers.get(SELF)));
    var p = _fetch.apply(this, arguments);
    if (!own && isCartMutation(url)) {
      var bundled = bodyHasSections(init && init.body);
      p.then(function (res) {
        if (!res.ok) return;
        if (/\/cart\/add/.test(url)) {
          res.clone().json().then(function (j) { onAdded(j); if (!bundled) refreshCartUI(); }).catch(function () { scheduleReconcile(); });
        } else {
          scheduleReconcile();
          if (!bundled) refreshCartUI();
        }
      }).catch(function () {});
    }
    return p;
  };
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this.__blpUrl = url; return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this;
    if (xhr.__blpUrl && isCartMutation(String(xhr.__blpUrl))) {
      var bundled = bodyHasSections(body);
      xhr.addEventListener('load', function () {
        if (xhr.status < 200 || xhr.status >= 300) return;
        if (/\/cart\/add/.test(String(xhr.__blpUrl))) {
          try { onAdded(JSON.parse(xhr.responseText)); } catch (e) { scheduleReconcile(); }
        } else { scheduleReconcile(); }
        if (!bundled) refreshCartUI();
      });
    }
    return _send.apply(this, arguments);
  };
  // the theme's own requests bundle `sections` and re-render the drawer themselves;
  // anything else (other apps, raw fetches) needs us to refresh the native drawer
  function bodyHasSections(body) {
    if (!document.querySelector('cart-drawer')) return true;
    try {
      if (!body) return false;
      if (typeof FormData !== 'undefined' && body instanceof FormData) return body.has('sections');
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return body.has('sections');
      return /sections/.test(String(body));
    } catch (e) { return false; }
  }

  function onAdded(json) {
    lastWasAdd = true;
    var items = json && json.items ? json.items : (json && json.variant_id ? [json] : []);
    // product-page collection-triggered gift offers for the variant that was just added
    var extra = [];
    items.forEach(function (it) {
      if (it.properties && it.properties[OFFER_PROP]) return;
      document.querySelectorAll('.blp-offer--gift[data-all="1"]').forEach(function (node) {
        if (currentPageVariantMatches(node, it.variant_id)) extra.push({ offerId: node.dataset.offer, triggerVariant: it.variant_id });
      });
      document.querySelectorAll('.blp-offer--gift[data-variants]').forEach(function (node) {
        if ((node.dataset.variants || '').split(',').indexOf(str(it.variant_id)) >= 0) extra.push({ offerId: node.dataset.offer, triggerVariant: it.variant_id });
      });
    });
    // ticked upsells
    var ups = collectTickedUpsells();
    var chain = Promise.resolve();
    if (ups.length) {
      chain = ownFetch(routes().add, { method: 'POST', body: JSON.stringify({ items: ups }) }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { console.warn('BLP Offers: upsell add failed', j); });
        document.querySelectorAll('.blp-upsell__check:checked').forEach(function (c) { c.checked = false; c.closest('.blp-upsell__row').classList.remove('is-checked'); });
        refreshCartUI();
      }).catch(function () {});
    }
    chain.then(function () { scheduleReconcile(extra); });
  }

  function currentPageVariantMatches(node, variantId) {
    // data-all offers are triggered by the page product itself (any of its variants)
    return (node.dataset.pvids || '').indexOf('|' + str(variantId) + '|') >= 0;
  }

  function collectTickedUpsells() {
    var out = [];
    document.querySelectorAll('.blp-offer--upsell:not([hidden]) .blp-upsell__check:checked').forEach(function (c) {
      var row = c.closest('.blp-upsell__row, .blp-up');
      var offer = c.closest('.blp-offer');
      var sel = row.querySelector('.blp-upsell__select');
      var vid = sel ? sel.value : row.dataset.variant;
      var props = {}; props[OFFER_PROP] = row.dataset.offer || offer.dataset.offer;
      out.push({ id: Number(vid), quantity: 1, properties: props });
    });
    return out;
  }

  // ---------- product page UI ----------
  function money(cents) {
    try {
      if (window.FoxTheme && FoxTheme.utils && FoxTheme.utils.formatMoney) return FoxTheme.utils.formatMoney(cents, FoxTheme.settings.moneyFormat);
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }

  function updateOfferVisibility() {
    var idInput = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    if (!idInput) return;
    var vid = str(idInput.value);
    document.querySelectorAll('.blp-offer[data-variants]').forEach(function (node) {
      var list = (node.dataset.variants || '').split(',');
      node.hidden = list.indexOf(vid) < 0;
    });
    // upsell cards are variant-specific individually; hide the row when no card is left
    document.querySelectorAll('.blp-up[data-variants]').forEach(function (card) {
      var list = (card.dataset.variants || '').split(',');
      card.hidden = list.indexOf(vid) < 0;
    });
    document.querySelectorAll('.blp-offer--upsell').forEach(function (block) {
      var visible = block.querySelectorAll('.blp-up:not([hidden])').length;
      block.hidden = visible === 0;
      var slider = block.querySelector('.blp-slider');
      if (slider) slider.classList.toggle('blp-slider--few', visible < 3);
    });
  }

  function bindUpsellRows() {
    document.querySelectorAll('.blp-upsell__row, .blp-up').forEach(function (row) {
      if (row.__blp) return; row.__blp = true;
      var check = row.querySelector('.blp-upsell__check');
      var sel = row.querySelector('.blp-upsell__select');
      var offer = row.closest('.blp-offer');
      if (check) check.addEventListener('change', function () { row.classList.toggle('is-checked', check.checked); });
      if (sel) {
        sel.addEventListener('click', function (e) { e.stopPropagation(); });
        sel.addEventListener('change', function () {
          var opt = sel.options[sel.selectedIndex];
          var price = Number(opt.dataset.price || 0);
          var src = row.dataset.discType ? row.dataset : offer.dataset;
          var type = src.discType, val = Number(src.discValue || 0);
          var now = type === 'amt' ? Math.max(0, price - Math.round(val * 100)) : Math.round(price * (100 - val) / 100);
          row.dataset.variant = sel.value;
          var nowEl = row.querySelector('.blp-upsell__now'), wasEl = row.querySelector('.blp-upsell__was');
          if (nowEl) nowEl.textContent = money(now);
          if (wasEl) wasEl.textContent = money(price);
        });
      }
    });
    document.querySelectorAll('.blp-gift__select').forEach(function (sel) {
      if (sel.__blp) return; sel.__blp = true;
      sel.addEventListener('change', function () {
        var card = sel.closest('.blp-gift__card');
        card.dataset.variant = sel.value;
        var opt = sel.options[sel.selectedIndex];
        var was = card.querySelector('.blp-gift__was');
        if (was) was.textContent = money(Number(opt.dataset.price || 0));
      });
    });
    document.querySelectorAll('.blp-slider').forEach(function (s) {
      if (s.__blp) return; s.__blp = true;
      var track = s.querySelector('.blp-slider__track');
      var bar = s.nextElementSibling && s.nextElementSibling.classList.contains('blp-slider__bar') ? s.nextElementSibling.querySelector('span') : null;
      function step() { var c = track.querySelector('.blp-up, .blp-upsell__row'); return c ? c.getBoundingClientRect().width + 8 : track.clientWidth; }
      s.querySelector('.blp-slider__btn--prev').addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      s.querySelector('.blp-slider__btn--next').addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      function updateBar() {
        if (!bar) return;
        var max = track.scrollWidth - track.clientWidth;
        var frac = track.clientWidth / track.scrollWidth;
        bar.style.width = Math.max(10, frac * 100) + '%';
        bar.style.left = (max > 0 ? (track.scrollLeft / max) * (100 - Math.max(10, frac * 100)) : 0) + '%';
      }
      track.addEventListener('scroll', updateBar, { passive: true });
      window.addEventListener('resize', updateBar);
      updateBar();
    });
    document.querySelectorAll('.blp-up__btn').forEach(function (btn) {
      if (btn.__blp) return; btn.__blp = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var card = btn.closest('.blp-up'), offer = btn.closest('.blp-offer');
        var sel = card.querySelector('.blp-upsell__select');
        var vid = sel ? sel.value : card.dataset.variant;
        var props = {}; props[OFFER_PROP] = card.dataset.offer || offer.dataset.offer;
        btn.disabled = true; var label = btn.textContent; btn.textContent = 'Adding…';
        lastWasAdd = true;
        ownFetch(routes().add, { method: 'POST', body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1, properties: props }] }) })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (j) { btn.textContent = (j && j.description) ? 'Unavailable' : 'Try again'; btn.disabled = false; });
            btn.textContent = 'Added ✓'; btn.classList.add('is-added');
            setTimeout(function () { btn.textContent = label; btn.classList.remove('is-added'); btn.disabled = false; }, 2500);
            refreshCartUI();
            scheduleReconcile();
          })
          .catch(function () { btn.textContent = label; btn.disabled = false; });
      });
    });
  }

  function init() {
    watchCartDrawer();
    bindUpsellRows();
    updateOfferVisibility();
    document.addEventListener('variant:changed', updateOfferVisibility);
    var idInput = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    if (idInput) idInput.addEventListener('change', updateOfferVisibility);
    // gift cards with a variant selector: honour the chosen variant when the gift is added
    // run once in case the cart already needs tidying (e.g. trigger removed while JS was not loaded)
    scheduleReconcile();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
